import { AntDesign, MaterialIcons } from "@expo/vector-icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, View, FlatList, Pressable, TextInput } from "react-native";

import i18n from "@/locales/i18n";
import { checkAsset, checkIcon } from "@/utils/transactions/ExchangeCurrencies";

interface AccountsListProps {
  data: any;
  selectAccount: (accountId: string) => void;
}

export default function AccountsList(props: AccountsListProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();

  const checkStatus = (status: string) => {
    if (status === "OPEN") {
      return "text-green";
    } else if (status === "INACTIVE") {
      return "text-red";
    } else {
      return "text-gray";
    }
  };

  const filteredAccounts =
    props.data?.filter(
      (account) =>
        account.id?.toLowerCase().includes(searchQuery?.toLowerCase())
    ) || [];

  return (
    <View className="w-full">
      <View className="w-fit">
        <View className="absolute left-4 top-3">
          <AntDesign name="search1" size={16} color="#BDBDBD" />
        </View>
        <TextInput
          className="border border-midgray rounded-full pl-10 py-2 text-base"
          placeholder={t("common:terms.searchaccountid")}
          placeholderTextColor="#BDBDBD"
          onChangeText={(text) => setSearchQuery(text)}
        />
      </View>
      <View className="w-full flex-row p-3">
        <View className="w-2/6 items-start justify-center lg:justify-start">
          <Text className="text-base font-light">
            {t("management/customer:accounts.id")}
          </Text>
        </View>
        <View className="w-1/6 items-start justify-center lg:justify-start">
          <Text className="text-base font-light">
            {t("management/customer:accounts.status")}
          </Text>
        </View>
        <View className="w-1/6 items-start justify-center lg:justify-start">
          <Text className="text-base font-light">
            {t("management/customer:accounts.asset")}
          </Text>
        </View>
        <View className="w-1/6 items-start justify-center lg:justify-start ">
          <Text className="text-base font-light">
            {t("management/customer:accounts.availablebalance")}
          </Text>
        </View>
        <View className="w-1/6 items-start justify-center lg:justify-start">
          <Text className="text-base font-light">
            {t("management/customer:accounts.currentbalance")}
          </Text>
        </View>
      </View>
      <FlatList
        data={filteredAccounts.length > 0 ? filteredAccounts : props.data}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <Pressable
            className="w-full flex-row transition-colors delay-0 bg-gray hover:bg-lightgray border border-lightgray rounded-lg p-3 mt-2"
            onPress={() => props.selectAccount(item.id)}
          >
            <View className="w-2/6">
              <Text numberOfLines={1} ellipsizeMode="middle">
                {item.id}
              </Text>
            </View>
            <View className="w-1/6">
              <Text className={`${checkStatus(item.status)}`}>
                {item.status}
              </Text>
            </View>
            <View className="flex-row w-1/6 items-center">
              {checkIcon(item.asset_type_id)}
              <Text className="mx-2">{checkAsset(item.asset_type_id)}</Text>
            </View>
            <View className="w-1/6">
              <Text>
                {checkAsset(item.asset_type_id) === "USD" ||
                checkAsset(item.asset_type_id) === "EUR"
                  ? new Intl.NumberFormat(i18n.language, {
                      style: "currency",
                      currency: "USD",
                    }).format(item.available_balance)
                  : item.available_balance}
              </Text>
            </View>
            <View className="w-1/6">
              <Text>
                {checkAsset(item.asset_type_id) === "USD" ||
                checkAsset(item.asset_type_id) === "EUR"
                  ? new Intl.NumberFormat(i18n.language, {
                      style: "currency",
                      currency: "USD",
                    }).format(item.current_balance)
                  : item.current_balance}
              </Text>
            </View>
            <MaterialIcons
              name="arrow-drop-down"
              size={24}
              color="#BDBDBD"
              className="absolute right-0 lg:right-3"
            />
          </Pressable>
        )}
      />
    </View>
  );
}
